export default "/images/framework/SaveAvatarCht.63f6180d.svg?63f6180d";